var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 22,
    viewBox: "0 0 40 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JM"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5215 21.9606V8.4989L21.3225 18.802V21.9606H15.5215Z",
    fill: "url(#paint0_diamond_17597_153784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M39.9993 21.9607V8.49902L34.1982 18.8021V21.9607H39.9993Z",
    fill: "url(#paint1_diamond_17597_153784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M39.9998 0.000366211L31.458 15.6056H24.0633L15.5215 0.000366211H20.9472L27.7607 12.4482L34.5741 0.000366211H39.9998Z",
    fill: "url(#paint2_diamond_17597_153784)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0 21.228V17.4001C1.11383 17.8927 2.41727 18.1388 3.91021 18.1388C5.29143 18.1388 6.27735 17.8535 6.86794 17.2826C7.45805 16.7118 7.75361 15.7773 7.75361 14.4788V0.0401611H12.2654V15.4861C12.2654 19.8293 9.7808 22.0004 4.81258 22.0004C3.00785 22.0004 1.40364 21.7428 0 21.228Z",
    fill: "url(#paint3_diamond_17597_153784)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond_17597_153784",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.44 46.0794) rotate(-94.3003) scale(47.8114 15.8342)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2228,
    stopColor: "#9A8938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53391,
    stopColor: "#E1D05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800558,
    stopColor: "#BB9A33"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_diamond_17597_153784",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.1168 46.0796) rotate(-94.3003) scale(47.8114 15.8342)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2228,
    stopColor: "#9A8938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53391,
    stopColor: "#E1D05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800558,
    stopColor: "#BB9A33"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_diamond_17597_153784",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.8367 43.5649) rotate(-105.308) scale(57.3014 64.6261)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2228,
    stopColor: "#9A8938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53391,
    stopColor: "#E1D05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800558,
    stopColor: "#BB9A33"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_diamond_17597_153784",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.1708 61.3458) rotate(-95.5666) scale(78.1444 33.4152)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2228,
    stopColor: "#9A8938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53391,
    stopColor: "#E1D05E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800558,
    stopColor: "#BB9A33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJm);
export default __webpack_public_path__ + "static/media/JM.ffc0c6a872cbd8657dd678e00114773a.svg";
export { ForwardRef as ReactComponent };